import { createSelector } from 'reselect';

export const storeName = 'activateAccount';

export const activateAccountSelector = state => ({ ...state[storeName] });

export const activateAccountResultSelector = createSelector(
  activateAccountSelector,
  activateAccount => activateAccount,
);
